// extracted by mini-css-extract-plugin
module.exports = {"counterOTP":"styles_counterOTP__le9UM","disabled":"styles_disabled__Yazdg"};